export default __webpack_public_path__ + "images/cce9c7ddedb590a337a9693243b448a0.svg";